import React from 'react'
import Phase3ProductQueuePage from 'domains/phase3-inbound-journey/pages/Phase3ProductQueuePage'
import Phase3InventoryBatchPage from 'domains/phase3-inbound-journey/pages/Phase3InventoryBatchPage'
import { PHASE3_PRODUCT_SCOPES } from 'domains/phase3-inbound-journey/constants'

const studio_team_routes = {
  collapse  : true,
  path      : '/studio-team',
  name      : 'Studio Team',
  icon      : 'fas fa-camera-retro text-red',
  state_key : 'studio_team_collapse',
  views     : [
    {
      path      : '/studio-team/inbound-journey/inventory-batches',
      name      : 'Inventory Batch',
      miniName  : 'IB',
      component : (props) => <Phase3InventoryBatchPage { ...props } apiNamespace='studio' />,
      layout    : '/app'
    },
    {
      path      : '/inbound-journey/studio',
      name      : 'Photo & Kelengkapan',
      miniName  : 'ST',
      component : (props) => <Phase3ProductQueuePage { ...props } scope={ PHASE3_PRODUCT_SCOPES.STUDIO } title='Photo & Kelengkapan' apiNamespace='studio' />,
      layout    : '/app'
    }
  ]
}

export default studio_team_routes
